import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "shorten_guid",
})
export class GuidPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return "";
    return value ? value.slice(0, 8) : "";
  }
}
